import React from 'react'
import photo from '../../assets/Z1.jpg' 
import { useFetch } from "../../hooks/useFetch";

const getServerStatus = ({ data, loading, error }) => {
  if (error) return "offline";
  if (loading) return "checking";
  return data.trim() === "Hello World from AleTower" ? "online" : "offline";
}

export const Villain = ({ currentDate, homeServerUrl, revisionDate, currently }) => {
  const timeDifference = currentDate - new Date('June 14, 2016');
  const streak = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  const serverResponse = useFetch(homeServerUrl, { as: "text", cache: false });
  const status = getServerStatus(serverResponse);

  // Replaces {{streak}} and {{status}} placeholders in the "currently" entries
  const values = { streak, status }
  const expand = (text) => text.replace(/\{\{(\w+)\}\}/g, (_, key) => values[key] ?? `{{${key}}}`);

  return (
    <div className='flex pt-16 mb-4 xl:pt-24 2xl:pt-32 xl:px-20 2xl:px-40 pb-4 px-6 font-sans bg-stone-100 dark:bg-stone-600 text-black dark:text-stone-200'>
        {/* PHOTO */}
        <div className='w-1/2 flex flex-col justify-center'>
          <div className='flex flex-col gap-2 bg-opache sm:w-5/6'>
            <img src={photo} className='rounded-full min-w-full aspect-square object-cover' alt='Foto Profilo'/>
            <div className='text-center italic dark:text-stone-200 font-thin text-[8px] xl:text-lg 2xl:text-xl sm:mt-2'>Latest revision: {revisionDate}</div>
          </div>
        </div>

        <div className='flex flex-col justify-center w-1/2 pl-4 xl:pl-8 2xl:pl-12'> 
            <div className='font-extrabold text-lg xl:text-6xl 2xl:text-7xl dark:text-white'>
              Currently:
            </div>
            <div className='text-xs xl:text-3xl 2xl:text-5xl'>
              <ul>
                {currently.map((entry, index) => (
                  <li key={index}>
                    - {expand(entry)}
                  </li>))
                }
              </ul>

            </div>
        </div>
        

    </div>
  )
}
